import React, { FC, useCallback, useState } from 'react'
import {
  Button,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core'
import { makeStyles, createStyles, useTheme } from '@material-ui/styles';

import { TNormalSlide, TNormalizedSlide } from 'src/screenhub-shared/types';

import { DisplaySubscriptionStatusEnums, IGetAccountDisplaySubscriptionStatus } from 'src/features/paywall/utils';
import { FEATURE_NAMES } from 'src/features/screenhub-pro/enum';

interface IProps {
  slide: TNormalizedSlide;
  accountDisplaySubscriptionStatusPromise: IGetAccountDisplaySubscriptionStatus;
  onOpenFeatureDesSubDialog?: (featureName: FEATURE_NAMES, tryItCallback?: () => void, shouldOpenForcibly?: boolean) => void;
  existingTemplateElementMeta?: { id: string, templateId: string }[];
}

const usePaperClasses = makeStyles<Theme>({
  root: {
    backgroundColor: '#ffd760',
    padding: '0 30px',
    width: '100%',
    minHeight: 32,
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 5,
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    boxShadow: 'none'
  }
});

const bannerText = 'Your display is set to skip this slide. Upgrade to Pro to unlock it.';

export const SlideIgnoreBanner: FC<IProps> = ({
  slide,
  accountDisplaySubscriptionStatusPromise,
  onOpenFeatureDesSubDialog,
  existingTemplateElementMeta,
}) => {
  const theme = useTheme();
  const paperClasses = usePaperClasses(theme);

  const elementsInSlide = (slide as TNormalSlide).elements;

  let hasExistingTemplateElements = false;

  if (elementsInSlide) {
    const existingTemplateElementIdSet = new Set(existingTemplateElementMeta.map(({ id }) => id));

    hasExistingTemplateElements = Object.values(elementsInSlide).some(({ id }) => (existingTemplateElementIdSet.has(id)));
  }

  const shouldShowBanner = (
    (accountDisplaySubscriptionStatusPromise?.status !== DisplaySubscriptionStatusEnums.PRO) &&
    hasExistingTemplateElements
  );

  const hanldeUpgradeClick = useCallback(() => {
    onOpenFeatureDesSubDialog && onOpenFeatureDesSubDialog(
      FEATURE_NAMES.template,
      undefined,
      true,
    );
  }, []);

  return shouldShowBanner ? (
    <>
      <Paper
        classes={paperClasses}
        elevation={1}
        square
      >
        {bannerText}
        <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
          <Button onClick={hanldeUpgradeClick} style={{ color: '#1D2026' }}>
            UPGRADE
          </Button>
        </Typography>
      </Paper>
    </>
  ) : (
    <></>
  )
}
